import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import $ from 'jquery'
import './feedback.min.js'
import 'feedback-tool/dist/feedback.min.css'

@inject('store') @observer
class Feedback extends Component {
  componentDidMount() {
    const token = localStorage.getItem('accessToken')
    $.feedback({
      feedbackButton: '.my-feedback-btn',
      ajaxURL: '/api/v1/leave-feedback',
      postHTML: false,
      postFunction: function (data) {
        data.headers = {'Authorization': `Bearer ${token}`}
        return $.ajax(data)
      }
    })
  }
  render() {
    return(
      <button
        className="my-feedback-btn feedback-btn feedback-btn-blue no-print"
        style={{
          fontSize: '14px',
          position: 'fixed',
          bottom: '20%',
          right: '-42px',
          width: 'auto',
          transform: 'rotate(-90deg)'
        }}
      >
        Send feedback
      </button>
    )
  }
}

export default Feedback
